<template>
	<div class="calclist-package bg-gray">
		<div class="calclist-box-title packageToggle">
			<span :class="['toggleArrow', !visible ? '' : 'open']" @click="toggle()">Alapcsomagja</span>
		</div>
		<div v-if="visible" class="form">
			<ul class="basic-package columns-2">
				<li class="label tick" v-for="basic in computedBasicEvents" :key="basic.id" v-if="basic.id !== 62 || getValuableSum > 0">
					{{ basic.name }}
                    <div v-if="basic.id === 62">
                        Fedezeti összeg: {{ (getValuableSum > 200000 ? 200000 : getValuableSum) | toCurrency }}
                    </div>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { filter } from 'lodash';

export default {
	props: {
		insurerCode: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			visible: false,
		};
	},
	computed: {
		...mapGetters(['getInsuranceEvents', 'getValuableSum']),
		computedBasicEvents() {
			return this.insurerCode === 'GEN'
				? this.getInsuranceEvents.basic
				: filter(this.getInsuranceEvents.basic, basic => basic.code !== 'JOGVED');
		},
	},
	methods: {
		toggle() {
			this.visible = !this.visible;
		},
	},
};
</script>
